var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSale2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8 20.6l-15-15c-.7-.7-1.8-1.1-2.8-1.1l-4 .3c-.9.1-1.8.5-2.4 1.1L8.3 7.1 5.4 4.2c-.3-.3-.9-.3-1.2 0-.3.3-.3.9 0 1.2l2.9 2.9-1.2 1.3c-.7.7-1.1 1.5-1.1 2.4l-.3 4c-.1 1.1.3 2.1 1.1 2.8l15 15c1.3 1.4 3.7 1.5 5.3 0l8-8c1.4-1.4 1.4-3.8-.1-5.2zm-1.1 4l-8 8c-.7.7-1.9.8-2.8 0l-15-15c-.4-.4-.6-.9-.5-1.5l.3-4c.1-.5.2-.9.5-1.3l1.3-1.3 2.3 2.3c.3.3.9.3 1.2 0 .3-.3.3-.9 0-1.2L9.5 8.3 10.8 7c.3-.3.8-.5 1.3-.5l4-.3c.6-.1 1.2.2 1.5.5l15 15c.8.9.8 2.1.1 2.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 15.3c-.3-.3-.9-.3-1.2 0l-4.4 4.4c-.3.3-.3.9 0 1.2.3.3.9.3 1.2 0l4.4-4.4c.4-.3.4-.8 0-1.2zM24.5 18.9c-.3-.3-.9-.3-1.2 0l-4.4 4.4c-.3.3-.3.9 0 1.2.3.3.9.3 1.2 0l4.4-4.4c.3-.3.3-.8 0-1.2zM26.9 22.5l-4.4 4.4c-.3.3-.3.9 0 1.2.3.3.9.3 1.2 0l4.4-4.4c.3-.3.3-.9 0-1.2-.4-.3-.8-.3-1.2 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale2);
export default __webpack_public_path__ + "static/media/sale-2.e45bd2f2.svg";
export { ForwardRef as ReactComponent };